<template>
  <div class="mx-sm-1 mt-9">
    <div class="page-header">
        <h1 class="page-title fw-bold">Les Classeurs</h1>
        <div>
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link :to="{ name: 'dashboard' }"><a>Tableau de bord</a></router-link></li>
                <li class="breadcrumb-item" aria-current="page"><router-link :to="{ name: 'composantes', params: { showList: true }}"><a>Portefeuille</a></router-link></li>
                <li class="breadcrumb-item active" aria-current="page"><router-link :to="{ name: 'classeurs' }"><a>Les Classeurs</a></router-link></li>
            </ol>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-8">
            <div class="card">
                <div class="card-header">
                    <h3 class="card-title fw-bold">Liste des classeurs</h3>
                    <div class="card-options">
<!--                        <SearchInputAll></SearchInputAll>-->
                        <button class="btn btn-outline-dark mx-5" @click="sentBackPortefeuille"><span class="fe fe-arrow-left-circle"></span> Retour sur Portefeuille</button>
                    </div>
                </div>
                <div class="card-body">
                  <GenericDataTable
                      ref="tableRef"
                      apiEndpoint="/classeurs/page"
                      :columns="columns"
                      :filterableFields="filterableFields"
                      :rowActions="rowActions"
                      :search-field="'nom'"
                      @edit="edit"
                      @drop="drop"
                      @initialized="initializedComposante"
                      @show="showComposantes"
                  >
                    <template #cell-createdAt="{ item }">
                      {{ item.createdAt | moment('DD-MM-YYYY HH:mm') }}
                    </template>
                  </GenericDataTable>

                </div>
            </div>
        </div>
        <div class="modal fade" id="modal-composantes" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-primary text-white">
                        <h6 class="modal-title fw-bold" style="font-size: 16px;">Les composantes du classeur</h6><button aria-label="Close" class="btn-close text-white"
                            data-bs-dismiss="modal" type="button"><span aria-hidden="true">×</span></button>
                    </div>
                    <div class="modal-body">
                        <ul class="row p-3">
                            <li class="col-lg-12 mb-2">
                                <h4 class="fw-bold">Classeur : {{ classeur?.idClasseur }} --- {{ classeur?.nomClasseur }}</h4>
                            </li>
                            <li class="col-lg-12 mb-2">
                                <div class="table-responsive">
                                    <table class="table table-hover table-bordered">
                                        <thead>
                                            <tr class="text-center info02">
                                                <th colspan="10" class="fw-bold">Composantes</th>
                                            </tr>
                                            <tr class="bg-light">
                                                <th class="bg-transparent border-bottom-0 fw-bold">Id Composante</th>
                                                <th class="bg-transparent border-bottom-0 fw-bold">Composante</th>
                                                <th class="bg-transparent border-bottom-0 fw-bold">
                                                    Etat</th>
                                                <th class="bg-transparent border-bottom-0 fw-bold">
                                                    Statut</th>
                                                <th class="bg-transparent border-bottom-0 fw-bold">
                                                    Météo</th>
                                                <th class="bg-transparent border-bottom-0 fw-bold">
                                                    Etudes</th>
                                                <th class="bg-transparent border-bottom-0 fw-bold">
                                                    Gouvernance</th>
                                                <th class="bg-transparent border-bottom-0 fw-bold">
                                                    Contrat</th>
                                                <th class="bg-transparent border-bottom-0 fw-bold">
                                                    Exécution</th>
                                                <th class="bg-transparent border-bottom-0 fw-bold">
                                                    Mise en service</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(composante, index) in filtersComposantes" :key="index">
                                                <td>{{ composante?.idComposante }}</td>
                                                <td>{{ composante?.nomComposante }}</td>
                                                <td class="text-center" >
                                                    <div class="mt-0 mt-sm-3 d-block">
                                                        <span class="p-2 px-2 alert" :style="'background-color: '  + statusEtat(composante?.etatComposante?.etat)">{{ composante?.etatComposante?.libelle }}</span>
                                                    </div>
                                                </td>
                                                <td class="text-center" >
                                                    <div class="mt-0 mt-sm-3 d-block">
                                                        <span class="p-2 px-2 alert" :style="'background-color: '  + statusStatut(composante?.statut?.statut)">{{ composante?.statut?.libelle }}</span>
                                                    </div>
                                                </td>
                                                <td class="text-center" :style="'background-color: '  + couleurMeteo(composante?.couleur)">
                                                    <span><small class="fw-bold">{{ composante?.couleur ? composante?.couleur : 'Blanc' }}</small></span>
                                                </td>
                                                <td class="text-center">
                                                    <span class="d-inline-block rounded-circle" :style="{
                                                        backgroundColor: couleurCritere(composante?.etudes), width: '30px', height: '30px', border: '1px solid #000000',
                                                        }" :title="composante?.etudes ? composante?.etudes : 'Non renseigné'"></span>
                                                </td>
                                                <td class="text-center">
                                                    <span class="d-inline-block rounded-circle" :style="{
                                                        backgroundColor: couleurCritere(composante?.gouvernance), width: '30px', height: '30px', border: '1px solid #000000',
                                                        }" :title="composante?.gouvernance ? composante?.gouvernance : 'Non renseigné'"></span>
                                                </td>
                                                <td class="text-center">
                                                    <span class="d-inline-block rounded-circle" :style="{
                                                        backgroundColor: couleurCritere(composante?.contrat), width: '30px', height: '30px', border: '1px solid #000000',
                                                        }" :title="composante?.contrat ? composante?.contrat : 'Non renseigné'"></span>
                                                </td>
                                                <td class="text-center">
                                                    <span class="d-inline-block rounded-circle" :style="{
                                                        backgroundColor: couleurCritere(composante?.execution), width: '30px', height: '30px', border: '1px solid #000000',
                                                        }" :title="composante?.execution ? composante?.execution : 'Non renseigné'"></span>
                                                </td>
                                                <td class="text-center">
                                                    <span class="d-inline-block rounded-circle" :style="{
                                                        backgroundColor: couleurCritere(composante?.miseEnService), width: '30px', height: '30px', border: '1px solid #000000',
                                                        }" :title="composante?.miseEnService ? composante?.miseEnService : 'Non renseigné'"></span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <nav class="mt-2">
                                    <ul class="pagination justify-content-end">
                                        <li class="page-item" :class="{ disabled: currentPage === 1 }">
                                            <a class="page-link" href="#" @click.prevent="changePage(currentPage - 1)">&laquo;</a>
                                        </li>
                                        <li v-for="page in pageCount" :key="page" class="page-item" :class="{ active: currentPage === page }">
                                            <a class="page-link" href="#" @click.prevent="changePage(page)">{{ page }}</a>
                                        </li>
                                        <li class="page-item" :class="{ disabled: currentPage === pageCount }">
                                            <a class="page-link" href="#" @click.prevent="changePage(currentPage + 1)">&raquo;</a>
                                        </li>
                                    </ul>
                                </nav>
                            </li>
                        </ul>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-gray" data-bs-dismiss="modal">Fermer</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- COL END -->
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-4">
            <div class="card overflow-hidden">
                <div class="card-header">
                    <h3 class="card-title fw-bold">{{ save ? 'Création d\'un classeur' : 'Modification d\'un classeur'}}</h3>
                </div>
                <div class="card-body">
                    <ValidationObserver ref="observer" v-slot="{ invalid }">
                        <form @submit.prevent="submit" class="">
                            <div class="form-row">
                                <div class="form-group col-md-12 mb-0">
                                    <ValidationProvider name="Identifiant" rules="" v-slot="{ errors }">
                                        <label class="form-label mx-2">ID CLASSEUR <span class="text-danger">*</span></label>
                                        <input type="text" class="form-control" id="idClasseur"  placeholder="saisir l'identifiant" readonly />
                                        <small class="form-text text-danger">{{ errors[0] }}</small>
                                    </ValidationProvider>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="form-group col-md-12 mb-0">
                                    <ValidationProvider name="Libelle" rules="required" v-slot="{ errors }">
                                        <label class="form-label">NOM CLASSEUR <span class="text-danger">*</span></label>
                                        <!-- <input type="text" class="form-control" id="nomClasseur" v-model="payload.nomClasseur" placeholder="saisir le nomClasseur" autocomplete="nomClasseur"> -->
                                        <textarea name="nomClasseur" v-model="payload.nomClasseur" class="form-control" id="nomClasseur" rows="3"></textarea>
                                        <small class="form-text text-danger">{{ errors[0] }}</small>
                                    </ValidationProvider>
                                </div>
                            </div>
                            <div class="form-footer mt-2 d-flex">
                                <div class="col-md-6">
                                    <button class="btn btn-success mt-4 mb-0" :disabled="invalid" v-if="save"><span class="fe fe-check"></span> Enregistrer</button>
                                    <button class="btn btn-success mt-4 mb-0" :disabled="invalid" v-else><span class="fe fe-check"></span> Modifier</button>
                                </div>
                                <!-- <div class="col-md-6">
                                    <router-link :to="{ name: 'composantes' }"><a href="javascript:void(0)" class="btn btn-danger mt-4 mb-0 text-end">Initialiser composante</a></router-link>
                                </div> -->
                            </div>
                        </form>
                    </ValidationObserver>
                </div>
            </div>
        </div>
    </div>
    <div class="row mt-5">
        <div class="col-md-8"></div>
        <div class="col-md-4">
            <h5 class="fw-bold mx-5">NB Composantes : XX</h5>
        </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { reduce } from "lodash";
import $ from 'jquery';
import { query } from 'vue-gtag';
import GenericDataTable from "../../components/GenericDataTable.vue";

const customLabels = {
  first: '<<',
  last: '>>',
  previous: '<',
  next: '>'
};

export default {
    name: "Classeurs",
  components: {GenericDataTable},
    data() {
        return {
            loading: false,
            payload: {idClasseur: '', nomClasseur: ''}, save: true, id: '', lesComposantes: [], classeur: {},
            currentPage: 1,
            perPage: 10,
            currentSort: 'idClasseur',
            currentSortDir: 'asc', customLabels,
            // columns: [
            //     { name: 'idClasseur', description: 'ID Classeur', type: 'text', used: false },
            //     { name: 'nomClasseur', description: 'Nom Classeur', type: 'text', used: false },
            // ],
            reinit: false,
            page: { name: 'size', description: '10 par page', value: 10, type: 'number', used: false },
            showFilter: false,
          columns: [
            { key: 'idClasseur', label: 'ID', class: 'text-center' },
            { key: 'nomClasseur', label: 'Nom', class: 'classeur-nom' },
          ],
          rowActions : [
            { name: 'edit', event: 'edit', icon: 'fe fe-edit fs-18 text-primary' },
            { name: 'delete', event: 'delete', icon: 'fe fe-trash-2 fs-18 text-danger' },
            { name: 'initialized', event: 'initialized', icon: 'fe fe-external-link fs-18 text-yellow' },
            { name: 'show', event: 'show', icon: 'fe fe-list fs-18 text-secondary' },
          ],
          filterableFields :[
            { key: 'id', label: 'ID Classeur', type: 'text', placeholder: 'Entrer un ID' },
            { key: 'nom', label: 'Nom Classeur', type: 'text', placeholder: 'Entrer un nom' },
          ]
        }
    },
    computed: {
        ...mapGetters({ items: 'classeurs/list' }),
        sortedItems() {
            return [...this.lesComposantes].sort((a, b) => {
                const aVal = this.resolveSortValue(a);
                const bVal = this.resolveSortValue(b);
                if (this.currentSortDir === 'asc') {
                return aVal > bVal ? 1 : -1;
                } else {
                return aVal < bVal ? 1 : -1;
                }
            });
        },
        filtersComposantes() {
            const start = (this.currentPage - 1) * this.perPage;
            return this.sortedItems.slice(start, start + this.perPage);
        },
        pageCount() {
            return Math.ceil(this.lesComposantes.length / this.perPage);
        },
        // filters() {
        //     return this.columns.filter(o => o.used);
        // },
        // option() {
        //     return reduce(this.filters, (acc, item) => (acc[item.name] = item.value, acc), {})
        // },
    },
    watch: {
        // page: {
        //     deep: true,
        //     immediate: true,
        //     handler(value) {
        //         this.reinit = true;
        //         this.onSearch();
        //     }
        // }
    },
    mounted(){
    },
    methods:{
        ...mapActions('classeurs', ['all', 'add', 'one', 'del', 'allPage']),
        hideModal(){
            $('#modal-composantes').modal('hide');
        },
        sortBy(column) {
            if (this.currentSort === column) {
                this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
            } else {
                this.currentSort = column;
                this.currentSortDir = 'asc';
            }
        },
        changePage(page) {
            if (page >= 1 && page <= this.pageCount) {
                this.currentPage = page;
            }
        },
        resolveSortValue(item) {
            const val = item[this.currentSort];
            if (this.currentSort === 'idComposante') {
                return item.idComposante?.idComposante;
            }else if (this.currentSort === 'nomComposante') {
                return item.idComposante?.nomComposante;
            }
            return typeof val === 'string' ? val.toLowerCase() : val;
        },
        // onSearch(offset) {
        //     this.$loading(true);
        //     if (offset > 0) this.option.page = offset - 1;
        //     if (this.reinit) {
        //         this.option.page = 0;
        //         this.reinit = false;
        //     }
        //     if (this.page) this.option.size = this.page.value
        //     //this.$router.push({ query: this.option }).catch(() => { });
        //     this.allPage(this.option).finally(() => this.$loading(false));
        // },
        sentBackPortefeuille(){
            this.$router.push({ name: 'composantes', params: { showList: true }})
        },
        onSearchBack(item) {
            item.used = false;
            // this.onSearch();
        },
      submit() {
        this.$loading(true);
        this.loading = true;

        const confirmationOptions = {
          title: "Confirmation",
          type: "warning",
          showCancelButton: true,
          closeOnConfirm: false,
          cancelButtonText: "Annuler",
          confirmButtonColor: "#7db0b2",
          cancelButtonColor: "#FF0000",
          showLoaderOnConfirm: true,
        };

        if (this.save) {
          console.log(this.payload);
          swal({
            ...confirmationOptions,
            text: "Etes-vous sûr de vouloir enregistrer le classeur ?",
            confirmButtonText: "Enregistrer",
          }, (result) => {
            if (result === true) {
              this.$loading(true);
              this.$http.get('/classeurs/genererIdClasseur', this.payload)
                  .then(({ data }) => {
                    if (data) {
                        this.payload.idClasseur = data;
                        this.$http.post('/classeurs', this.payload)
                        .then(({ data }) => {
                            if (data) {
                                swal('Information!', 'Classeur enregistré avec succès.', 'success');
                                this.$refs.tableRef.loadData();
                                this.payload = { idClasseur: '', nomClasseur: '' };
                                if (this.$refs.observer) {
                                    this.$refs.observer.reset();
                                }
                            } else {
                                swal('Information!', 'L\'enregistrement du classeur n\'a pas pu être effectué.', 'warning');
                            }
                        })
                        .catch((error) => {
                            swal('Information!', 'Une erreur est survenue lors de l\'enregistrement. ' + error, 'warning');
                            this.payload.idClasseur = '';
                        })
                        .finally(() => this.$loading(false));
                    }
              })
              .catch((error) => {
                swal('Information!', 'Une erreur est survenue lors de la génération du Id Classeur. ' + error, 'error');
                this.payload.idClasseur = '';
              })
              .finally(() => this.$loading(false));
            }
          });
        } else {
          console.log("Editer", this.payload);
          console.log('ID === ', this.id);
          swal({
            ...confirmationOptions,
            text: "Etes-vous sûr de vouloir modifier le classeur ?",
            confirmButtonText: "Modifier",
          }, (result) => {
            if (result === true) {
              this.$loading(true);
              this.$http.put('/classeurs/' + this.id, this.payload)
                  .then(({ data }) => {
                    if (data) {
                      swal('Information!', 'Classeur modifié avec succès.', 'success');
                      this.$refs.tableRef.loadData();
                      this.payload = { idClasseur: '', nomClasseur: '' };
                      if (this.$refs.observer) {
                        this.$refs.observer.reset();
                      }
                    } else {
                      swal('Information!', 'La modification du classeur n\'a pas pu être effectuée.', 'warning');
                    }
                  })
                  .catch((error) => {
                    swal('Information!', 'Une erreur est survenue lors de la modification. ' + error, 'warning');
                  })
                  .finally(() => this.$loading(false));
            }
          });
        }
      },

      edit(value){
            this.$loading(true);
            this.save = false;
            this.payload = {...value};
            this.id = this.payload.idClasseur;
            this.$loading(false);
        },
        drop(item){
            console.log(item.idClasseur)
            const self = this;
            swal({
                title: "Confirmation",
                text: "Etes-vous sûr de vouloir supprimer le classeur ?",
                type: "warning",
                showCancelButton: true,
                closeOnConfirm: false,
                cancelButtonText: "Annuler",
                confirmButtonText: "Supprimer",
                confirmButtonColor: "#7db0b2",
                cancelButtonColor: "#FF0000",
                showLoaderOnConfirm: true
            }, (result) => {
                if (result === true) {
                    self.$loading(true);
                    self.$http.delete('/classeurs/' + item.idClasseur)
                    .then(({data}) => {
                        swal('Information!', 'Classeur supprimé avec succès.', 'success');
                        // self.onSearch();
                      this.$refs.tableRef.loadData();
                    })
                    .catch((error) => {
                        swal('Information!', 'Une erreur est survenue lors de la suppression. ' + error, 'warning');
                    })
                    .finally(() => self.$loading(false));
                }
            });
        },
        initializedComposante(item){
            this.$router.push({ name: 'composantes' , params: { idClasseur: item, showList: false } });
        },
        showComposantes(item){
            this.$loading(true);
            this.$http.get('/composantes/classeurs/' + item.idClasseur)
            .then(({data}) => {
                if (data.length > 0) {
                    this.lesComposantes = data;
                    this.classeur = item;
                    $('#modal-composantes').modal('show');
                } else {
                    this.lesComposantes = [];
                    swal('Information!', 'Aucune composante disponible pour ce classeur.', 'error');
                }
            })
            .catch((error) => {
                swal('Information!', 'Erreur lors du chargement des composantes : ' + error, 'error');
                console.error('Erreur lors du chargement des composantes :', error);
            })
            .finally(() => {
                this.$loading(false);
            });
        },
        statusEtat(value) {
            switch (value) {
                case 'SUSPENDU':
                    return '#000000';
                case 'ANNULE':
                    return '#000000';
                case 'ACTIF':
                    return '#C6E0B4';
                case 'CLOTURE':
                    return '#8EA9DB';
                case 'DOUBLON':
                    return '#F2F2F2';
                case 'PLANIFIE':
                    return '#F2F2F2';
                case 'A_SUPPRIMER':
                    return '#F2F2F2';
                case 'NON_DEMARRE':
                    return '#F2F2F2';
                case 'A_CONFIRMER':
                    return '#F2F2F2';
                case 'PLUS':
                    return '#F2F2F2';
                case 'X':
                    return '#F2F2F2';
                case 'NA':
                    return '#F2F2F2';
                default:
                    return '#F2F2F2'; //PROCESSED
            }
        },
        statusStatut(value) {
            switch (value) {
                case '00':
                    return '#F2F2F2';
                case '01':
                    return '#E2EFDA';
                case '02':
                    return '#C6E0B4';
                case '03':
                    return '#8EA9DC';
                case '04':
                    return '#ACB9CA';
                default:
                    return '#F2F2F2'; //PROCESSED
            }
        },
        couleurMeteo(value){
            switch (value) {
                case 'Noir':
                    return '#000000';
                case 'Orange':
                    return '#FFC000';
                case 'Rouge':
                    return '#FF0000';
                case 'Vert':
                    return '#00B050';
                case 'Bleu':
                    return '#4472C4';
                case 'Blanc':
                    return '#FFFFFF';
                default:
                    return '#FFFFFF';
            }
        },
        couleurCritere(value){
            if(parseInt(value) >= 3){
                return '#00B050';
            }else if(parseInt(value) >= 2 && parseInt(value) < 3){
                return '#FFC000';
            }else if(parseInt(value) >= 1 && parseInt(value) < 2){
                return '#FF0000';
            }else if(parseInt(value) < 1){
                return '#000000';
            }else {
                return '#FFFFFF';
            }
        },
    },
    created() {
        // this.onSearch();
    }
}
</script>

<style>
th {
  cursor: pointer;
}
.classeur-nom {
  max-width: 220px;
  white-space: normal !important;
  word-wrap: break-word;
  word-break: break-word;
}
</style>